import { InjectionToken } from '@angular/core';

/** Folder name under the published `@angular-workspace/feature/canvas` package for SVG/logo assets (see `ng-package.json` assets). */
export const CANVAS_ICONS_PACKAGE_DIR = 'icons';

/**
 * Browser URL prefix where canvas toolbar SVGs are served.
 * Copy `libs/feature/src/lib/canvas/icons/*.svg` into the app build output (e.g. under `assets/canvas-icons`).
 */
export const CANVAS_ICONS_BASE_URL = new InjectionToken<string>('CANVAS_ICONS_BASE_URL', {
  providedIn: 'root',
  factory: () => '/assets/canvas-icons',
});
